import { FilterItemConfig } from '../types/filter-config';

export function getQueryColumn<T extends object, TValue>(config: FilterItemConfig<T>): any {
  if(config.type === 'entity')
    return `${config.field}.${config.queryColumn}`;
  return config.field;
}
